var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { CrossIcon } from '@shapeable/icons';
export var MapPopupDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    z-index: 100;\n    position: relative;\n    border-radius: 12px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n    margin-bottom: 10px;\n  "], ["\n    background: ", ";\n    z-index: 100;\n    position: relative;\n    border-radius: 12px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n    margin-bottom: 10px;\n  "])), theme.COLOR('canvas'))
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    cursor: pointer;\n    ", "\n\n    &:hover {\n      ", "\n    }\n  "], ["\n    ", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    cursor: pointer;\n    ", "\n\n    &:hover {\n      ", "\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(2), theme.UNIT(2), theme.FILL('text'), theme.FILL('link-hover'))
});
var CloseIconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n  "], ["\n    width: 20px;\n    height: 20px;\n  "])))
});
var TriangleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 0; \n    height: 0; \n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #FFF;\n    position: absolute;\n    bottom: -9px;\n    left: 50%;\n    margin-left: -10px;\n  "], ["\n    width: 0; \n    height: 0; \n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #FFF;\n    position: absolute;\n    bottom: -9px;\n    left: 50%;\n    margin-left: -10px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CloseButton: styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  CloseIcon: styled(CrossIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CloseIconStyles),
  Triangle: styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TriangleStyles)
};
export var MapPopup = function (props) {
  var className = props.className,
    children = props.children,
    onClose = props.onClose;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.CloseButton, {
    type: "button",
    onClick: onClose,
    title: "Close"
  }, React.createElement(My.CloseIcon, null)), children, React.createElement(My.Triangle, null));
};
MapPopup.defaultProps = MapPopupDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;